import { render, staticRenderFns } from "./form-section.vue?vue&type=template&id=2eed15c2&scoped=true"
import script from "./form-section.vue?vue&type=script&lang=js"
export * from "./form-section.vue?vue&type=script&lang=js"
import style0 from "./form-section.vue?vue&type=style&index=0&id=2eed15c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed15c2",
  null
  
)

export default component.exports